import c from "@emotion/styled/base";
const I = /* @__PURE__ */ c("td", process.env.NODE_ENV === "production" ? {
  target: "e1wql3hh0"
} : {
  target: "e1wql3hh0",
  label: "StyledCell"
})("padding:8px 12px;", ({
  css: b
}) => b, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvVGFibGUvc3ViQ29tcG9uZW50cy9DZWxsL0NlbGwuc3R5bGVkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUc4RSIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9wYXJ0b28tdWkvcGFydG9vLXVpL3BhY2thZ2VzL3VpL3NyYy9jb21wb25lbnRzL1RhYmxlL3N1YkNvbXBvbmVudHMvQ2VsbC9DZWxsLnN0eWxlZC50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuZXhwb3J0IGNvbnN0IFN0eWxlZENlbGwgPSBzdHlsZWQudGQ8eyBjc3M/OiBSZXR1cm5UeXBlPHR5cGVvZiBjc3M+IHwgc3RyaW5nIH0+YFxuICAgIHBhZGRpbmc6IDhweCAxMnB4O1xuICAgICR7KHsgY3NzIH0pID0+IGNzc307XG5gO1xuIl19 */"));
export {
  I as StyledCell
};
